import { useTranslation } from 'react-i18next';

export function ProductLengthGridHeader({
  hasPrice,
  hasCarts,
  priceLabel,
}: Readonly<{
  hasPrice: boolean;
  hasCarts: boolean;
  priceLabel?: string;
}>) {
  const { t } = useTranslation('inventory');

  return (
    <div role="row" className="contents">
      <span role="columnheader" className="sr-only">
        {t('inventory.product_name')}
      </span>
      <span role="columnheader" className="sr-only">
        {t('inventory.product_code')}
      </span>
      <span role="columnheader" className="sr-only">
        {t('inventory.length')}
      </span>
      {hasPrice ? (
        <span role="columnheader" className="sr-only">
          {priceLabel ?? t('inventory.buy_list.price')}
        </span>
      ) : null}
      <span role="columnheader" className="sr-only">
        {t('inventory.buy_list.quantity')}
      </span>
      {hasCarts ? (
        <span role="columnheader" className="sr-only">
          {t('inventory.buy_list.in_carts')}
        </span>
      ) : null}
    </div>
  );
}
